import { motion, useTransform } from 'framer-motion';
import { BRAND_MARK_DEFAULTS } from '@/shared/components/brand-mark';
import { useBrand } from '@/shared/lib/brand';
import { useSidebarMotion } from '@/shared/lib/sidebar-motion';

const { iconSize: ICON_SIZE, wordmarkSize: WORDMARK_SIZE, gap: BRAND_GAP } = BRAND_MARK_DEFAULTS;

/**
 * Marca da sidebar — o ícone não se move (fica na coluna dos ícones do menu) e o
 * logotipo, de largura fixa, é revelado pela borda da sidebar enquanto ela abre,
 * com fade e um leve deslize acompanhando o mesmo progresso.
 */
export function SidebarBrand() {
  const { brand } = useBrand();
  const { progress, reveal } = useSidebarMotion();
  const wordmarkX = useTransform(progress, [0, 1], [-8, 0]);
  const displayWordmarkSize = Math.round(WORDMARK_SIZE * brand.logotypeScale);
  const wordmarkWidth = Math.round(displayWordmarkSize * brand.logotypeAspect);

  return (
    <div className="flex shrink-0 items-center">
      <img
        src={brand.assets.icon.brand}
        alt=""
        width={ICON_SIZE}
        height={ICON_SIZE}
        decoding="async"
        className="shrink-0 object-contain"
        style={{ width: ICON_SIZE, height: ICON_SIZE }}
      />
      <motion.div
        aria-hidden
        className="relative shrink-0"
        style={{
          width: wordmarkWidth,
          height: displayWordmarkSize,
          marginLeft: BRAND_GAP,
          opacity: reveal,
          x: wordmarkX,
        }}
      >
        <img
          src={brand.assets.logotype.light}
          alt=""
          width={wordmarkWidth}
          height={displayWordmarkSize}
          decoding="async"
          className="absolute inset-0 h-full w-full object-contain object-left dark:hidden"
          style={{ filter: brand.assets.logotype.lightFilter }}
        />
        <img
          src={brand.assets.logotype.dark}
          alt=""
          width={wordmarkWidth}
          height={displayWordmarkSize}
          decoding="async"
          className="absolute inset-0 hidden h-full w-full object-contain object-left dark:block"
        />
      </motion.div>
    </div>
  );
}
